import React from "react"
import { ClickableMap } from "components/page-components/Ausschreibungsdienste/landingpage-components/utils"
import { Link } from "gatsby"

export const TopRegions = () => {
  return (
    <div className="columns">
      <div className="column is-6 is-flex is-flex-direction-column is-justify-content-space-between has-text-mitternachtsblau">
        <div style={{ marginTop: "auto", marginBottom: "auto" }}>
          <p className="title is-2 is-spaced is-size-3-touch">
            Ausschreibungen aus allen Bundesländern
          </p>

          <p className="has-text-weight-bold mt-6 mb-4">
            Ausschreibungen für spezielle Gewerke
          </p>

          <p>
            Wir helfen Ihnen, Aufträge zu finden, <br />
            die genau zu den Leistungen Ihres Unternehmens passen.
          </p>

          <div
            className="columns is-multiline is-variable is-0 mt-4 has-text-weight-bold"
            style={{ textDecoration: "underline" }}
          >
            <div className="column is-5">
              <Link
                to={
                  "/ausschreibungsdienste/ausschreibungen/bauleistungen/malerarbeiten"
                }
              >
                Ausschreibungen für Maler
              </Link>
            </div>
            <div className="column is-5">
              <Link
                to={
                  "/ausschreibungsdienste/ausschreibungen/bauleistungen/trockenbau"
                }
              >
                Trockenbau Ausschreibungen
              </Link>
            </div>
            <div className="column is-5">
              <Link
                to={
                  "/ausschreibungsdienste/ausschreibungen/dienstleistungen/gebaeudereinigung"
                }
              >
                Gebäudereinigungs-Aufträge
              </Link>
            </div>
            <div className="column is-5">
              <Link
                to={
                  "/ausschreibungsdienste/ausschreibungen/dienstleistungen/auftraege-fuer-planungsleistungen"
                }
              >
                Ausschreibungen für Planungsbüros
              </Link>
            </div>
          </div>
        </div>

        <div style={{ marginTop: "auto", marginBottom: "auto" }}>
          <hr style={{ width: "70%" }} className="is-mitternachtsblau-30" />

          <p className="has-text-weight-bold">Top-Regionen:</p>

          <div
            className="columns is-multiline is-variable is-0 mt-4 has-text-weight-bold "
            style={{ textDecoration: "underline" }}
          >
            <div className="column is-5">
              <Link
                to={
                  "/ausschreibungsdienste/ausschreibungen/region/nordrhein-westfalen"
                }
              >
                Ausschreibungen aus NRW
              </Link>
            </div>
            <div className="column is-5">
              <Link
                to={
                  "/ausschreibungsdienste/ausschreibungen/region/niedersachsen"
                }
              >
                Ausschreibungen Niedersachsen
              </Link>
            </div>
            <div className="column is-5">
              <Link
                to={"/ausschreibungsdienste/ausschreibungen/region/brandenburg"}
              >
                Ausschreibungen aus Brandenburg
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="column is-5 is-offset-1">
        <ClickableMap />
      </div>
    </div>
  )
}
